<template>
  <div class="registUserInfoWrap">
    <form :action="action" :method="method" ref="profileForm">
      <input type="hidden" name="_token" :value="csrfToken">
      <div class="registUserInfo" v-show="step === 1">
        <h1 class="registUserInfo__title">占いに使う情報を登録</h1>
        <p class="registUserInfo__body">プロフィール情報を入力してください。後から追加・変更することもできます。</p>
        <div class="registUserInfo__form">
          <template v-for="item in tagLabelList">
            <input
              type="hidden"
              name="tag_label[]"
              :value="item"
            />
          </template>
          <template v-for="item in tagIdList">
            <input
              type="hidden"
              name="tag_id[]"
              :value="item"
            />
          </template>
          <ProfileForm
            :csrf-token="csrfToken"
            :action="action"
            method="POST"
            :is-regist="true"
            style="padding:0;"
            @next="next"
          />
        </div>
      </div>
      <select-theme-worried :setting-data="settingData" v-show="step === 2" @selectTheme="regist"/>
      <div class="personalize" v-show="step === 3">
        <h1 class="personalize__title" v-html="personalizeText"></h1>
         <personarize-progress
          :trigger="progressStart"
          @complete="progressComplete"
          />
        <div
          class="mess"
          ref="mess"
          :class="{show: progComp}"
          ></div>
        <p class="personalize__text">気に入ってもらえそうな占いを探しています。</p>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BaseButton from './common/BaseButton'
import { FORM_OPTIONS } from '@/CONSTS'
import PersonarizeProgress from "./partials/PersonarizeProgress";
import ProfileForm from "./ProfileForm";


export default {
  name: 'registUserInfo',
  components:{
    BaseButton,
    PersonarizeProgress,
    ProfileForm
  },
  props: {
    csrfToken: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: ''
    },
    settingData:{
      type: Object,
      default: ()=>{}
    },
  },
  data() {
    return {
      FORM_OPTIONS,
      buttonIsDisabled: false,
      progressStart: false,
      progComp: false,
      step:1,
      tagLabelList:[],
      tagIdList:[],
      userInfo:{}
    }
  },
  computed: {
    personalizeText(){
      return this.userInfo.nickname ? `${this.userInfo.nickname}さんのための<br>プレイリストを作成中`:'あなたのために<br>選んだ占いをお届けします。'
    }
  },
  methods: {
    next(userInfo){
      this.userInfo = userInfo
      this.step = 2
      window.scrollTo(0, 0);
    },
    regist(val){
      this.step = 3
      this.$refs.mess.addEventListener('transitionend', this.complete)
      this.progressStart = true

      //気になるテーマ（カテゴリ）・気になる占い・気になる占い師のテキスト配列を作成
      this.tagLabelList = this.tagLabelList.concat(val.theme)
      this.tagLabelList = this.tagLabelList.concat(val.fortune)
      this.tagLabelList = this.tagLabelList.concat(val.teller)

      //気になるテーマ（タグ）IDの配列を作成
      Object.keys(val.worried).forEach((key) =>{
        this.tagIdList = this.tagIdList.concat(val.worried[key])
      })
    },
    progressComplete(){
      this.progComp = true
    },
    complete(){
      //プログレス処理完了
      this.$refs.mess.removeEventListener('transitionend', this.complete)
      this.dataSubmit()
    },
    dataSubmit() {
      this.$refs.profileForm.submit()
    },
  }
}
</script>

<style lang="scss">
@import "../../../sass/commons/commonVariables.scss";
.registUserInfoWrap{
  color: $col_base_black;
  padding: 35px 20px 60px;
  max-width: 580px;
  margin: auto;
}

.registUserInfo{
  padding: 0 10px;
  &__title{
    font-size: 21px;
    line-height: 31px;
    text-align: center;
    margin: 4px 0 30px;
  }

  &__body{
    font-size: 13px;
    line-height: 21px;
    margin-bottom: 30px;
  }

  &__form{
    &__set{
      display: flex;
      div + div{
        margin-left: 3px;
      }
    }
  }

  &__button{
    margin: 40px 0;
  }
}

.personalize{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  &__title{
    white-space: pre-line;
    font-size: 18px;
    text-align: center;
    margin: 30px 0 45px;
  }

  &__text{
    font-size: 13px;
    text-align: center;
    margin-top: 45px;
  }
}

.mess {
  padding-top: 8px;
  color: $col_temp_key1;
  transform: scale(2.0, 1.2);
  opacity: 0;
  transition: all 300ms ease-out 0s;
  filter: blur(5px);
  &.show {
    transform: scale(1, 1);
    filter: blur(0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/RegistUserInfo.vue